module.exports = __webpack_public_path__ + "static/9-6b4e6a3beed2d92145da2d75116f3614.png";